<template>
    <div class="admin-table">
        <v-container fluid
                     class="pa-0 ma-0">
            <v-row>
                <v-col v-if="createButtonText"
                       cols="12" sm="4" md="3" xl="2">
                    <v-btn @click="createItem"
                           class="w-100"
                           color="lonely"
                           variant="flat">{{createButtonText}}</v-btn>
                </v-col>
                <v-col v-if="canResetHeaders"
                       cols="12" sm="4" md="3" xl="2">
                    <v-btn @click="resetHeaders"
                           class="w-100"
                           color="lonely"
                           variant="flat">Восстановить столбцы</v-btn>
                </v-col>
                <v-col cols="12" sm="auto" class="ml-sm-auto">
                    <div class="float-right mt-sm-3">
                        <span class="text-primary font-weight-bold">
                            Всего записей: {{itemsCount}}
                        </span>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table v-model:items-per-page="itemsCountPerPage"
                                  hover
                                  width="auto"
                                  :headers="headers"
                                  :items="items"
                                  :search="searchString">
                        <template v-slot:top>
                            <v-text-field v-model="searchString"
                                          clearable
                                          label="Поиск"
                                          class="mb-n4"></v-text-field>
                        </template>

                        <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
                            <tr>
                                <template v-for="column in columns" :key="column.key">
                                    <td class="v-data-table__td v-data-table__th">
                                        <div :class="getDivClasses(null, null, column)">
                                            <span class="mr-1 cursor-pointer text-primary font-weight-bold"
                                                  @click="() => toggleSort(column)">{{ column.title }}</span>
                                            <v-icon v-if="isSorted(column)"
                                                    class="text-primary"
                                                    :icon="getSortIcon(column)"
                                                    title="Сортировать"
                                                    @click="() => toggleSort(column)" />
                                            <v-icon v-if="column.removable"
                                                    class="text-primary"
                                                    icon="$close"
                                                    title="Удалить"
                                                    @click="() => removeHeader(column.key)" />
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>

                        <template v-slot:item="{ item, columns }">
                            <tr class="v-data-table__tr">
                                <template v-for="column in columns" :key="column.key + item.id">
                                    <td v-if="column.key === 'buttons'"
                                        class="v-data-table__td">
                                        <div :class="getDivClasses(null, null, column)">
                                            <v-icon v-if="goToHandler"
                                                    icon="mdi-arrow-right-thin-circle-outline"
                                                    title="Перейти"
                                                    :class="getItemClasses(column.key, item)"
                                                    @click="() => goToHandler(item.rawItem)" />

                                            <v-icon icon="mdi-pencil-circle-outline"
                                                    title="Редактировать"
                                                    :class="getItemClasses(column.key, item)"
                                                    @click="() => editItem(item.rawItem)" />
                                        </div>
                                    </td>
                                    <td v-else
                                        class="v-data-table__td">
                                        <div :class="getDivClasses(null, null, column)">
                                            <span :class="getItemClasses(column.key, item)">
                                                {{item[column.key]}}
                                            </span>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        props: {
            items: Array,
            getNewItem: Function,
            getHeaders: Function,
            createButtonText: String,
            goToHandler: Function
        },

        emits: ["edit:item"],

        components: {

        },

        data() {
            return {
                itemsCountPerPage: 10,
                headers: this.getHeaders(),
                searchString: ""
            };
        },

        computed: {
            canResetHeaders() {
                return this.headers.length !== this.getHeaders().length;
            },
            itemsCount() {
                return this.items?.length ?? 0;
            }
        },

        watch: {

        },

        methods: {
            getDivClasses(columnName, columns, column) {
                if (!column) {
                    column = columns.find(c => c.key === columnName);
                }

                if (!column) {
                    return "";
                }

                let classes = "d-flex align-center";

                if (column.align === "start") {
                    classes += " justify-start";
                } else if (column.align === "center") {
                    classes += " justify-center";
                } else if (column.align === "end") {
                    classes += " justify-end";
                }

                if (column.title === "Id") {
                    classes += " id-column";
                } else if (column.title === "Guid") {
                    classes += " guid-column";
                }

                return classes;
            },

            getItemClasses(columnName, item) {
                if (!item.isGreyRow) {
                    if (columnName === "id" || columnName === "buttons") {
                        return "text-primary";
                    }

                    return "text-tabular";
                }

                return "text-grey-lighten-1";
            },

            createItem() {
                const data = {
                    item: this.getNewItem(),
                    editItem: false
                };

                this.$emit("edit:item", data);
            },

            editItem(item) {
                const data = {
                    item: item,
                    editItem: true
                };

                this.$emit("edit:item", data);
            },

            removeHeader(key) {
                this.headers = this.headers.filter(header => header.key !== key);

                if (!this.headers || this.headers.length === 0) {
                    this.resetHeaders();
                }
            },

            resetHeaders() {
                this.headers = this.getHeaders();
            }
        }
    };
</script>

<style lang="scss">
    .admin-table .cursor-pointer {
        cursor: pointer;
    }

    .admin-table .v-data-table-footer {
        color: rgb(var(--v-theme-primary)) !important;
        font-weight: bold;
    }

    .admin-table .v-data-table.v-table table tr td .id-column {
        min-width: 50px !important;
        max-width: 50px !important;
    }

    .admin-table .v-data-table.v-table table tr td .guid-column {
        min-width: 160px !important;
        max-width: 160px !important;
    }

    .admin-table .v-data-table.v-table table tr td {
        overflow: hidden;
    }
</style>